<template>
  <v-app id="materialpro" :class="`${!$vuetify.display.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`">
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
  created: function () {
    this.$vuetify.locale.current = this.$store.getters.getLanguage;
  },
};
</script>
<style lang="scss">
@import './assets/css/main.css';
</style>